import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enNewOverviews from '/public/locales/en/newOverviews.json';
import enConstructionSteps from '/public/locales/en/constructionSteps.json';
import enStatic from '/public/locales/en/static.json';
import frNewOverviews from '/public/locales/fr/newOverviews.json';
import frConstructionSteps from '/public/locales/fr/constructionSteps.json';
import frStatic from '/public/locales/fr/static.json';
import constructionSteps from './app/construction/stepCard';

i18n
    .use(initReactI18next)
    .init({
        resources: {
        en: {
            newOverviews: enNewOverviews,
            constructionSteps: enConstructionSteps,
            static: enStatic,
        },
        fr: {
            newOverviews: frNewOverviews,
            constructionSteps: frConstructionSteps,
            static: frStatic,
        },
        },
        lng: 'fr', // Default language
        fallbackLng: 'fr', // Fallback language
        ns: ['newOverviews', 'static', 'constructionSteps'], // Declare your namespaces here
        defaultNS: 'static', // Default namespace to use
        interpolation: {
        escapeValue: false, // React already escapes values
        },
        react: {
        useSuspense: false, // Important for SSR
        },
    });

export default i18n;